import { getCaregiverService } from "@/util/api-helper";

export const fetchCellularInfoById = async (childId: string) => {
  const caregiverService = await getCaregiverService();
  const response = await caregiverService.getCellularInfo(childId);
  return response.data;
};
